import { Id, toast, TypeOptions } from 'react-toastify';

export const formatRecipients = (count: number) => `${count.toLocaleString('fr-FR')} destinataire(s)`;

export const settleToast = (id: Id, type: TypeOptions, render: string, autoClose = 5000) =>
  toast.update(id, { render, type, isLoading: false, autoClose });
